import clsx from "clsx";
import {
  OutlineEmailIconComponent,
  SmartPhoneIconComponent,
} from "assets/icons";
import useTranslation from "hooks/useTranslation";
import styles from "./styles.module.scss";

function EditingField({
  type,
  editInfo,
  userInfo,
  errorObject,
  setUserInfo,
  onConfirm,
  onDiscard,
}) {
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  const detailsOnType = {
    email: {
      icon: OutlineEmailIconComponent,
      title: t("EMAIL"),
      inputType: "email",
    },
    phone: {
      icon: SmartPhoneIconComponent,
      title: t("PHONE"),
      inputType: "text",
    },
  };

  const title = detailsOnType[type].title;
  const Icon = detailsOnType[type].icon;
  const value = editInfo[type]?.value || userInfo[type];
  const inputType = detailsOnType[type].inputType;
  const hasError = !!errorObject[type];

  const handleChangeField = (e) => {
    setUserInfo(type, e.target.value);
  };

  return (
    <div className="w-100">
      <div className="conv__userinfo__card__info__fields__inner__row__title no-flex userinfo_item">
        <Icon className={styles.userinfo_icon} />
        {title} :
      </div>
      <div className="flex flex-jc-sb flex-ai-c w-100 flex-columngap-8">
        <div
          data-error={hasError}
          className="conv__userinfo__card__info__fields__inner__row__value input_styles flex-grow-1"
        >
          <input
            className={clsx(
              "conv__userinfo__card__info__fields__inner__row__value__input",
              styles.input
            )}
            defaultValue={value}
            type={inputType}
            onChange={handleChangeField}
            autoFocus
          />
        </div>

        <div className="actions flex flex-ai-c flex-columngap-8">
          <div
            onClick={() => onConfirm(type, false)}
            className="actions__confirm"
            data-tool-tip-top={t("CONFIRM")}
          />
          <div
            onClick={() => onDiscard(type, false)}
            className="actions__reject no-margin"
            data-tool-tip-top={t("CANCEL")}
          />
        </div>
      </div>
    </div>
  );
}

export default EditingField;
